import { toast } from "react-toastify";
import { endpoints } from "../../../configs/Settings";
import { HTTPResponseStatus } from "../../../utils/enum";
import { useAxios } from "../../../utils/useAxios";
import { getAuthToken } from "@/services/auth/OAuthApplication";

interface IProps {
  id?: string;
  practitioner?: string;
  organization?: string;
  includeOrganization?: boolean;
  includePractitioner?: boolean;
  specialty?: string;
  count?: string;
  authAplication?: boolean;
}

/**
 * Busca PractitionerRole no servidor FHIR
 * @param id - ID do PractitionerRole
 * @param practitioner - ID do Practitioner
 * @param organization - ID da Organization
 * @param specialty - Código da especialidade
 * @param count - Quantidade de resultados
 * @param includeOrganization - Incluir Organization relacionada
 * @param includePractitioner - Incluir Practitioner relacionado
 * @param authAplication - Flag de autenticação da aplicação
 * @returns Bundle com PractitionerRole(s)
 */
export async function GetPractitionerRole({
  id,
  practitioner,
  organization,
  specialty,
  count,
  includeOrganization,
  includePractitioner,
  authAplication,
}: IProps) {
  // Construir URL base
  let baseUrl = `${endpoints.ADMFHIR}/PractitionerRole`;

  // Se tiver ID, retorna direto o recurso
  if (id) {
    baseUrl = `${baseUrl}/${id}`;
  }

  // Construir parâmetros de query
  const queryParams: string[] = [];

  // Adicionar parâmetros de busca
  if (practitioner) {
    queryParams.push(`practitioner=${encodeURIComponent(practitioner)}`);
  }

  if (organization) {
    queryParams.push(`organization=${encodeURIComponent(organization)}`);
    queryParams.push("_include=PractitionerRole:practitioner");
  }

  if (includeOrganization) {
    queryParams.push("_include=PractitionerRole:organization");
  }

  if (includePractitioner) {
    queryParams.push("_include=PractitionerRole:practitioner");
  }

  if (specialty) {
    queryParams.push(`specialty:code=${encodeURIComponent(specialty)}`);
  }

  // Adicionar parâmetros de paginação
  if (count) {
    queryParams.push(`_count=${count}`);
  }

  // Construir URL final
  const url =
    !id && queryParams.length > 0
      ? `${baseUrl}?${queryParams.join("&")}`
      : baseUrl;

  const headers = {
    Accept: "*/*",
    Authorization: await getAuthToken(),
    "Content-Type": "application/fhir+json",
  };

  const response = await useAxios
    .get(url, { headers, timeout: 20000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Success) {
        throw new Error(`GetPractitionerRole: ${response.status}`);
      }
      return response.data;
    })
    .catch((error) => {
      console.error("GetPractitionerRole ", error);
      // toast.error(`GetPractitionerRole Error: ${error?.response?.status}`);
      throw new Error();
    });

  if (response) return response;
}
